// Contenido de tours, guías y glosario (Prompt 19). Editar textos SOLO aquí — nunca en los
// componentes — para no tener microtextos regados por toda la app.

export const TOURS = {
  dashboard: [
    {
      element: '[data-tour="dashboard-period"]',
      popover: {
        title: "Elige el periodo",
        description: "Aquí eliges qué periodo estás viendo: este mes, el pasado, el año…",
      },
    },
    {
      element: '[data-tour="global-company-switch"]',
      popover: {
        title: "Elige la compañía",
        description: "Aquí eliges si ves todo junto, solo Álvarez o solo Trébol.",
      },
    },
    {
      element: '[data-tour="dashboard-kpis"]',
      popover: {
        title: "El resumen del dinero",
        description:
          "Estas tarjetas son el resumen: lo cobrado, lo que te deben, lo vencido y lo que falta pagar a carriers. Tocando cada una vas al detalle.",
      },
    },
    {
      element: '[data-tour="dashboard-sin-fecha"]',
      popover: {
        title: "Fecha estimada",
        description:
          "Los viajes que en el Excel no traían fecha de entrega usan una fecha estimada. Por eso algunos cobros dicen \"(vencim. estimado)\".",
      },
    },
    {
      element: '[data-tour="help-button"]',
      popover: {
        title: "Ayuda siempre a la mano",
        description: "Si te pierdes, este botón siempre te muestra la ayuda. Está en todas las pantallas.",
      },
    },
  ],
  loads: [
    {
      element: '[data-tour="loads-search"]',
      popover: {
        title: "Buscar un viaje",
        description: "Escribe aquí un número de viaje, una referencia o una factura, como buscar en el Excel.",
      },
    },
    {
      element: '[data-tour="loads-numero-column"]',
      popover: {
        title: "De quién es el viaje",
        description: "El número te dice de quién es el viaje: AL- es Álvarez, T es Trébol americano y TN- es Trébol nacional.",
      },
    },
    {
      element: '[data-tour="loads-filtros-compania-tipo"]',
      popover: {
        title: "Filtrar por compañía y tipo",
        description: "Con estos filtros ves solo una compañía o solo un tipo de viaje (nacional, importación, exportación).",
      },
    },
    {
      element: '[data-tour="loads-cobro-column"]',
      popover: {
        title: "El semáforo de cobro",
        description: "Verde: al corriente. Amarillo: por vencer. Rojo: vencido. Aquí registras cuando el cliente ya pagó.",
      },
    },
    {
      element: '[data-tour="loads-export"]',
      popover: {
        title: "Bajar a Excel",
        description: "Lo que estés viendo lo puedes bajar a Excel cuando quieras.",
      },
    },
    {
      element: '[data-tour="loads-new"]',
      popover: {
        title: "Nuevo viaje",
        description: "Aquí das de alta un viaje nuevo.",
      },
    },
  ],
  cruces: [
    {
      element: '[data-tour="cruces-tabs"]',
      popover: {
        title: "Importaciones y exportaciones",
        description: "Aquí están separadas las importaciones y las exportaciones, como las hojas de tu Excel.",
      },
    },
    {
      element: '[data-tour="cruces-filtros"]',
      popover: {
        title: "Filtrar cruces",
        description: "Puedes filtrar por fecha, cliente, unidad, referencia o status.",
      },
    },
    {
      element: '[data-tour="cruces-carta-porte-column"]',
      popover: {
        title: "Cartas porte",
        description: "Cada cruce trae sus cartas porte nacional y de cruce.",
      },
    },
    {
      element: '[data-tour="cruces-export"]',
      popover: {
        title: "Bajar a Excel",
        description: "También puedes bajar los cruces a Excel.",
      },
    },
  ],
  cajas: [
    {
      element: '[data-tour="cajas-tabs-principal"]',
      popover: {
        title: "Catálogo y movimientos",
        description: "Catálogo: tus cajas y dónde quedó cada una. Movimientos: todo lo que se ha movido, separado impo/expo.",
      },
    },
    {
      element: '[data-tour="cajas-search"]',
      popover: {
        title: "Buscar una caja",
        description: "Busca una caja por su número y ve todo su historial.",
      },
    },
    {
      element: '[data-tour="cajas-status-column"]',
      popover: {
        title: "El status",
        description: "El status es el mismo texto que manejan en el Excel (ENTREGADO, CRUCE, etc.).",
      },
    },
  ],
};

// B1 — tabla de equivalencias con el Excel del cliente. `countKey` referencia un fetcher en
// Guias.js que trae el conteo EN VIVO desde la API existente (no números fijos).
export const EQUIVALENCIAS = [
  {
    excel: "LOGISTICA USA",
    plataforma: "Viajes → números AL-#### y T####",
    countKey: "logistica_usa",
    to: "/loads?tipo_viaje=nacional_us",
    boton: "Llévame ahí",
  },
  {
    excel: "NACIONALES",
    plataforma: "Viajes → números TN-##### (filtro \"Nacional MX\")",
    countKey: "nacionales",
    to: "/loads?tipo_viaje=nacional_mx",
    boton: "Llévame ahí",
  },
  {
    excel: "IMPORTACIONES",
    plataforma: "Cruces → pestaña Importaciones",
    countKey: "cruces_impo",
    to: "/cruces?sentido=impo",
    boton: "Llévame ahí",
  },
  {
    excel: "EXPORTACIONES",
    plataforma: "Cruces → pestaña Exportaciones",
    countKey: "cruces_expo",
    to: "/cruces?sentido=expo",
    boton: "Llévame ahí",
  },
  {
    excel: "CAJAS IMPO y CAJAS EXPO",
    plataforma: "Cajas → Movimientos (pestañas Impo/Expo)",
    countKey: "cajas_movs",
    to: "/cajas?tab=movimientos",
    boton: "Llévame ahí",
  },
  {
    excel: "UNIDADES",
    plataforma: "Unidades",
    countKey: "unidades",
    to: "/unidades",
    boton: "Llévame ahí",
  },
  {
    excel: "DIRECTORIO CLIENTES",
    plataforma: "Clientes → abrir un cliente → Contactos",
    countKey: null,
    to: "/clients",
    boton: "Llévame ahí",
  },
  {
    excel: "REFERENCIAS CUMMINS",
    plataforma: "Ref. Cummins",
    countKey: "referencias_cummins",
    to: "/referencias-cummins",
    boton: "Llévame ahí",
  },
  {
    excel: "TARIFARIO",
    plataforma: "Tarifario",
    countKey: "tarifario",
    to: "/rate-cards",
    boton: "Llévame ahí",
  },
];

// B2 — recetas (máx. 6 pasos, tono simple)
export const RECETAS = [
  {
    titulo: "Buscar un viaje, referencia o factura",
    pasos: [
      "Tocá la lupa arriba a la derecha (o presioná la tecla /).",
      "Escribí el número de viaje, la referencia o la factura.",
      "Esperá a que aparezcan los resultados agrupados.",
      "Tocá el resultado para abrirlo.",
    ],
    to: "/loads",
  },
  {
    titulo: "Ver solo importaciones o solo exportaciones",
    pasos: [
      "Abrí Cruces desde el menú.",
      "Tocá la pestaña Importaciones o Exportaciones arriba de la tabla.",
      "Los demás filtros (fecha, cliente, unidad) siguen funcionando igual.",
    ],
    to: "/cruces",
  },
  {
    titulo: "Ver solo lo de Álvarez o solo lo de Trébol",
    pasos: [
      "Arriba, en el selector de compañía, tocá Álvarez o Trébol.",
      "Todas las pantallas de dinero (Viajes, Resumen, Reportes) se filtran solas.",
      "Truco: los números que empiezan con AL- son de Álvarez; T y TN- son de Trébol.",
    ],
    to: "/loads",
  },
  {
    titulo: "Saber cuánto te deben y quién",
    pasos: [
      "Abrí Resumen.",
      "Tocá la tarjeta \"Pendiente de cobro\".",
      "Para el detalle completo, abrí Reportes → Cuentas por cobrar.",
    ],
    to: "/reports?tab=cxc",
  },
  {
    titulo: "Registrar que un cliente ya pagó",
    pasos: [
      "Abrí Viajes y buscá el viaje.",
      "Tocá el viaje para abrirlo.",
      "Tocá \"Registrar cobro\" y completá fecha y referencia.",
    ],
    to: "/loads",
  },
  {
    titulo: "Dar de alta un viaje nuevo",
    pasos: [
      "Abrí Viajes.",
      "Tocá \"Nuevo load\".",
      "Elige compañía, tipo de viaje y cliente.",
      "Completá la ruta y la tarifa.",
      "Guardá.",
    ],
    to: "/loads/nuevo",
  },
  {
    titulo: "Ver el historial de una caja",
    pasos: [
      "Abrí Cajas.",
      "Buscá el número de caja en el catálogo.",
      "Ahí ves su último movimiento; en la pestaña Movimientos ves todo su historial.",
    ],
    to: "/cajas",
  },
  {
    titulo: "Ver los cruces de una semana",
    pasos: [
      "Abrí Cruces.",
      "Completá \"Desde\" y \"Hasta\" con las fechas que quieras.",
      "La tabla se actualiza sola.",
    ],
    to: "/cruces",
  },
  {
    titulo: "Bajar a Excel lo que estás viendo",
    pasos: [
      "En cualquier pantalla con tabla, buscá los botones CSV o Excel arriba.",
      "Tocá el que prefieras — se descarga con los filtros que tengas puestos.",
    ],
    to: "/loads",
  },
  {
    titulo: "Entender los colores (semáforos)",
    pasos: [
      "Verde: al corriente, no hay que hacer nada.",
      "Amarillo: por vencer, ya casi.",
      "Rojo o naranja: vencido, hay que cobrar.",
      "\"(vencim. estimado)\" significa que el viaje no tenía fecha de entrega en el Excel, así que la plataforma calculó una fecha estimada desde el despacho.",
    ],
    to: "/loads",
  },
];

// B3 — glosario corto
export const GLOSARIO = [
  { termino: "Load", definicion: "Es lo mismo que \"viaje\": un embarque con su cobro y sus costos." },
  { termino: "Serie AL / T / TN", definicion: "El principio del número te dice la compañía: AL- Álvarez, T- Trébol USA, TN- Trébol nacional." },
  { termino: "Cruce", definicion: "El paso de un embarque por la frontera, con su carta porte y su status." },
  { termino: "Movimiento de caja", definicion: "Un cruce hecho con una caja (contenedor) de la flota propia, impo o expo." },
  { termino: "Carrier vs Operador", definicion: "Carrier es el transportista americano externo que contratás; Operador es tu propio chofer." },
  { termino: "Semáforo de cobro", definicion: "El color que indica si un cobro está al corriente (verde), por vencer (amarillo) o vencido (rojo/naranja)." },
  { termino: "(vencim. estimado)", definicion: "El viaje no tenía fecha de entrega en el Excel; la plataforma calculó una fecha estimada desde el despacho." },
  { termino: "Margen", definicion: "Lo que te queda de ganancia sobre lo que cobraste, en porcentaje." },
  { termino: "Carta porte nac. / de cruce", definicion: "Los dos documentos de transporte: uno para el tramo nacional y otro para el cruce de frontera." },
  { termino: "Bloqueado", definicion: "Un viaje ya cobrado y con todos sus costos pagados — queda de solo lectura hasta que el Dueño lo desbloquee." },
];
